// eslint-disable-next-line import/prefer-default-export
export const subscribePrice = 19.99;
export const ovp = 'Harmonics';
export const videoPlayer = 'Bitmovin';
export const playerName = 'YES-Web';